import { render, staticRenderFns } from "./lab-test-platform-update.vue?vue&type=template&id=747882bd&"
import script from "./lab-test-platform-update.vue?vue&type=script&lang=js&"
export * from "./lab-test-platform-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports